module.exports = __webpack_public_path__ + "img/Integrity.efda35c3.png";